import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, OnDestroy, OnInit, Output, ViewEncapsulation, signal } from '@angular/core'
import { Router } from '@angular/router'
import { ValidatorService } from '../../../common/utilities/validator.service'
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { UserInputService } from 'src/app/common/api/services/user-input.service'
import { ProgressiveProfileService } from 'src/app/common/api/services/progressive-profile.service'
import { DatePipe, ViewportScroller, NgClass } from '@angular/common'
import { GtmImplementation } from 'src/app/common/api/services/gtmImplementation'
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter'
import { MAT_DATE_FORMATS, DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core'
import moment from 'moment'
import { FormFieldHelperService } from 'src/app/common/utilities/form-field-helper.service'
import { englishTestNamesContent } from 'src/app/common/json/english-test-names'
import { englishProficiencyContent } from '../../../common/json/english-proficiency-content'
import { MatChipListbox, MatChipOption } from '@angular/material/chips';
import { MatFormField, MatSuffix } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker, MatDatepickerActions, MatDatepickerCancel, MatDatepickerApply } from '@angular/material/datepicker';

export const MY_DATE_FORMAT2 = {
  parse: {
    dateInput: 'DD/MM/YYYY'
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
}

@Component({
    selector: 'app-english-proficiency',
    templateUrl: './english-proficiency.component.html',
    styleUrls: ['./english-proficiency.component.css'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMAT2 },
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] }
    ],
    imports: [FormsModule, ReactiveFormsModule, MatChipListbox, MatChipOption, MatFormField, NgClass, MatSelect, MatOption, MatInput, MatDatepickerInput, MatSuffix, MatDatepickerToggle, MatDatepicker, MatDatepickerActions, MatDatepickerCancel, MatDatepickerApply]
})
export class EnglishProficiencyComponent implements OnInit, OnDestroy {
  questions: any
  englishProficiencyDetailsForm: any
  officeDetails: any
  selectedLanguage: any
  academicDetailsNotValid: boolean = false
  showEngDetailsLoader = signal(false)
  submitted: any
  invalidTestDate: boolean = false
  futureTestDate: boolean = false
  yesterdayDate = moment().subtract(1, 'day')
  todayDate = moment()
  testScoreConfig: any = null
  englishTestNames: any[] = englishTestNamesContent
  showTestType: boolean = false
  showTestDate: boolean = false
  showOverallScore: boolean = false
  showTooltip: boolean = false
  showOtherTestName: boolean = false
  hasExistingEnglishTestData: boolean = false
  englishTestFieldsRequired: boolean = false
  private isRestoring: boolean = false
  country: any
  defaultLanguage = 'EN'
  testDetailsText: any
  otherTestNameText: any
  enterTestNameText: any
  infoTooltipText: any
  invalidDateText: any
  pastDateText: any
  enterScoreText: any
  scoreAtLeastText: any
  scoreNotExceedText: any
  validScoreBetweenText: any
  andText: any
  backText: any
  nextText: any
  optionalText: any
  cancelText: any
  applyText: any
  datePlaceholderText: any
  @Output() nextClicked = new EventEmitter<void>()
  @Output() backClicked = new EventEmitter<void>()

  constructor (
    public route: Router,
    public fb: FormBuilder,
    public userInputService: UserInputService,
    public viewPortScroller: ViewportScroller,
    public validatorService: ValidatorService,
    public gtmImplementation: GtmImplementation,
    public ProgressiveProfileQuestionsService: ProgressiveProfileService,
    private el: ElementRef,
    public datePipe: DatePipe,
    private formFieldHelper: FormFieldHelperService,
    private cdr: ChangeDetectorRef
  ) {
    this.englishProficiencyDetailsForm = this.fb.group({})
  }

  showScrollBtnEng: boolean = false
  isScrollingEng: boolean = false
  private scrollTimer: any = null
 
  @HostListener('window:scroll')
  onWindowScroll (): void {
    this.showScrollBtnEng = window.scrollY > 50
    this.isScrollingEng = true
    this.cdr.detectChanges()
    clearTimeout(this.scrollTimer)
    this.scrollTimer = setTimeout(() => { 
      this.isScrollingEng = false
      this.cdr.detectChanges()
    }, 300)
  }

  ngOnInit (): void {
    this.viewPortScroller.scrollToPosition([0, 0])
    this.gtmImplementation.pageView('english_proficiency', 'signed_in_user', 'user_registration')
    this.selectedLanguage = localStorage.getItem('languageSelected') ? localStorage.getItem('languageSelected') : 'EN'
    const sfResponse: any = localStorage.getItem('sfResponse')
    const officeDetails: any = JSON.parse(sfResponse)
    this.country = officeDetails?.wir_country_code
    this.getLanguageContent(this.selectedLanguage)
    this.getProgressiveProfileQstns()
  }

  getLanguageContent (language: any): any {
    if (language === 'EN') {
      this.testDetailsText = englishProficiencyContent[language]?.testDetails
      this.otherTestNameText = englishProficiencyContent[language]?.otherTestName
      this.enterTestNameText = englishProficiencyContent[language]?.enterTestName
      this.infoTooltipText = englishProficiencyContent[language]?.infoTooltip
      this.invalidDateText = englishProficiencyContent[language]?.invalidDate
      this.pastDateText = englishProficiencyContent[language]?.pastDate
      this.enterScoreText = englishProficiencyContent[language]?.enterScore
      this.scoreAtLeastText = englishProficiencyContent[language]?.scoreAtLeast
      this.scoreNotExceedText = englishProficiencyContent[language]?.scoreNotExceed
      this.validScoreBetweenText = englishProficiencyContent[language]?.validScoreBetween
      this.andText = englishProficiencyContent[language]?.and
      this.backText = englishProficiencyContent[language]?.back
      this.nextText = englishProficiencyContent[language]?.next
      this.optionalText = englishProficiencyContent[language]?.optional
      this.cancelText = englishProficiencyContent[language]?.cancel
      this.applyText = englishProficiencyContent[language]?.apply
      this.datePlaceholderText = englishProficiencyContent[language]?.datePlaceholder
    } else {
      this.testDetailsText = englishProficiencyContent[this.country + '_' + language]?.testDetails
      this.otherTestNameText = englishProficiencyContent[this.country + '_' + language]?.otherTestName
      this.enterTestNameText = englishProficiencyContent[this.country + '_' + language]?.enterTestName
      this.infoTooltipText = englishProficiencyContent[this.country + '_' + language]?.infoTooltip
      this.invalidDateText = englishProficiencyContent[this.country + '_' + language]?.invalidDate
      this.pastDateText = englishProficiencyContent[this.country + '_' + language]?.pastDate
      this.enterScoreText = englishProficiencyContent[this.country + '_' + language]?.enterScore
      this.scoreAtLeastText = englishProficiencyContent[this.country + '_' + language]?.scoreAtLeast
      this.scoreNotExceedText = englishProficiencyContent[this.country + '_' + language]?.scoreNotExceed
      this.validScoreBetweenText = englishProficiencyContent[this.country + '_' + language]?.validScoreBetween
      this.andText = englishProficiencyContent[this.country + '_' + language]?.and
      this.backText = englishProficiencyContent[this.country + '_' + language]?.back
      this.nextText = englishProficiencyContent[this.country + '_' + language]?.next
      this.optionalText = englishProficiencyContent[this.country + '_' + language]?.optional
      this.cancelText = englishProficiencyContent[this.country + '_' + language]?.cancel
      this.applyText = englishProficiencyContent[this.country + '_' + language]?.apply
      this.datePlaceholderText = englishProficiencyContent[this.country + '_' + language]?.datePlaceholder
    }
  }

  toggleTooltip (event: Event): void {
    if (window.innerWidth <= 700) {
      event.stopPropagation()
      this.showTooltip = !this.showTooltip
    }
  }

  closeTooltip (event: Event): void {
    event.stopPropagation()
    this.showTooltip = false
  }

  onInputChange (field: string, value: any, event?: any): any {
    if (this.isRestoring) return
    const storageKey = this.getStorageKey(field)
    if (event?.selected === false) {
      this.userInputService.deleteValue(storageKey)
      // When englishIsFirstLanguage chip is deselected, hide all test fields
      if (field === 'englishIsFirstLanguage') {
        this.showTestType = false
        this.showTestDate = false
        this.showOverallScore = false
        this.showOtherTestName = false
        this.englishTestFieldsRequired = false
        this.testScoreConfig = null
        this.clearEnglishTestFields()
        this.updateFormValidation()
      }
      return
    }

    this.userInputService.setValue(storageKey, value)

    if (field === 'englishIsFirstLanguage') {
      this.handleEnglishFirstLanguageChange(value)
    } else if (field === 'testType') {
      this.handleTestTypeChange(value)
    } else if (field === 'otherTestName') {
      this.userInputService.setValue('other_english_testType', value)
    }
  }

  private handleEnglishFirstLanguageChange (value: any): void {
    const actualValue = typeof value === 'string' ? value : value?.option_value
    if (actualValue === 'Yes' || actualValue?.toLowerCase() === 'yes') {
      if (!this.hasExistingEnglishTestData) {
        this.clearEnglishTestFields()
      }
      this.showTestType = false
      this.showTestDate = false
      this.showOverallScore = false
      this.showOtherTestName = false
      this.updateFormValidation()
    } else if (actualValue === 'No' || actualValue?.toLowerCase() === 'no') {
      this.showTestType = true
      if (this.hasExistingEnglishTestData) {
        this.isRestoring = true
        this.restoreFormValues()
        this.isRestoring = false
        this.restoreConditionalFields()
      }
      this.updateFormValidation()
    }
  }

  private handleTestTypeChange (value: any): void {
    const testName = typeof value === 'string' ? value : (value?.option_desc || value?.option_label)
    const testId = typeof value === 'string' ? null : value?.option_value
    const isOthers = testId === 'tt_11' || testName?.toLowerCase() === 'others'
    const isNotTaken = testId === 'tt_16' || testName?.toLowerCase() === 'not taken'

    if (isOthers) {
      this.showOtherTestName = true
      this.showTestDate = true
      this.showOverallScore = true
      this.testScoreConfig = null
      const overallScoreControl = this.englishProficiencyDetailsForm.get('overallScore')
      overallScoreControl?.clearValidators()
      overallScoreControl?.updateValueAndValidity()
    } else {
      this.showOtherTestName = false
      this.formFieldHelper.clearFields(this.englishProficiencyDetailsForm, ['otherTestName'], 'other_english')

      if (!testName || isNotTaken) {
        this.clearTestDateAndScore()
        this.testScoreConfig = null
        this.showTestDate = false
        this.showOverallScore = false
      } else {
        this.updateTestScoreConfig(testName)
        this.showTestDate = true
        this.showOverallScore = true
      }
    }
    this.updateFormValidation()
  }

  private clearTestDateAndScore (): void {
    this.formFieldHelper.clearFields(this.englishProficiencyDetailsForm, ['testTakenDate', 'overallScore'], 'english')
    this.invalidTestDate = false
    this.futureTestDate = false
  }

  private clearTestTypeAndRest (): void {
    this.formFieldHelper.clearFields(this.englishProficiencyDetailsForm, ['testType', 'testTakenDate', 'overallScore'], 'english')
    this.formFieldHelper.clearFields(this.englishProficiencyDetailsForm, ['otherTestName'], 'other_english')
    this.showOtherTestName = false
    this.invalidTestDate = false
    this.futureTestDate = false
  }

  clearEnglishTestFields (): void {
    this.formFieldHelper.clearFields(this.englishProficiencyDetailsForm, ['testType', 'testTakenDate', 'overallScore'], 'english')
    this.formFieldHelper.clearFields(this.englishProficiencyDetailsForm, ['otherTestName'], 'other_english')
    this.showOtherTestName = false
    this.invalidTestDate = false
    this.futureTestDate = false
    this.testScoreConfig = null
  }

  clearSelection (field: string): void {
    this.englishProficiencyDetailsForm.get(field)?.setValue('')
    this.userInputService.deleteValue(this.getStorageKey(field))
    if (field === 'testType') {
      this.clearTestDateAndScore()
      this.showTestDate = false
      this.showOverallScore = false
      this.showOtherTestName = false
      this.testScoreConfig = null
      this.formFieldHelper.clearFields(this.englishProficiencyDetailsForm, ['otherTestName'], 'other_english')
    }
    this.updateFormValidation()
  }

  getProgressiveProfileQstns (): any {
    this.questions = this.ProgressiveProfileQuestionsService.serviceQuestions?.items[0]?.fields?.questions

    const englishCpCallDone = this.userInputService.getValue('english_cp_call_done')
    if (englishCpCallDone !== 'true') {
      this.userInputService.setValue('english_cp_call_done', 'true')
      this.prePopulateFromCP()
    }
    if (this.questions === undefined) {
      this.showEngDetailsLoader.set(true)
      this.ProgressiveProfileQuestionsService.getPPqstns().subscribe(
        (res: any) => {
          this.questions = res.items[0].fields.questions
          this.generateFormControl(this.questions)
          this.showEngDetailsLoader.set(false)
        },
        (error: any) => {
          console.log(error)
          this.showEngDetailsLoader.set(false)
          this.route?.navigateByUrl('/error')
        }
      )
    } else {
      this.generateFormControl(this.questions)
    }
  }

  prePopulateFromCP (): void {
    const cpResponse = this.userInputService.getValue('cp_response')
    if (!cpResponse) return

    const englishIsFirst = cpResponse.studentAdditionalInfo?.englishIsFirstLanguage
    if (englishIsFirst) {
      // Look up the proper option_label from PP question options
      const englishQ = this.questions?.find((q: any) => q.mappingField === 'englishIsFirstLanguage')
      const matchedOption = englishQ?.options?.find((o: any) => o.option_value?.toLowerCase() === englishIsFirst.toLowerCase())
      const optionLabel = matchedOption?.option_label || englishIsFirst
      this.userInputService.setValue('englishIsFirstLanguage', { option_value: englishIsFirst, option_label: optionLabel })
    }

    const englishTest = cpResponse.qualification_details?.englishTest
    if (!englishTest || Object.keys(englishTest).length === 0) return

    this.hasExistingEnglishTestData = true
    this.prePopulateTestType(englishTest)
    if (englishTest.testTakenDate) {
      const formattedDate = moment(englishTest.testTakenDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
      this.userInputService.setValue('english_testTakenDate', { option_value: formattedDate, option_label: formattedDate })
    }
    if (englishTest.overallScore) {
      this.userInputService.setValue('english_overallScore', { option_value: englishTest.overallScore.toString(), option_label: englishTest.overallScore.toString() })
    }
  }

  private prePopulateTestType (englishTest: any): void {
    if (!englishTest.testType && !englishTest.testTypeId) return

    // Check if it's a 'not taken' value first
    const isNotTaken = englishTest.testTypeId === 'tt_16' || englishTest.testType?.toLowerCase() === 'not taken'
    if (isNotTaken) {
      const testTypeQ = this.questions?.find((q: any) => q.mappingField === 'testType' && q.questionAttributeId === 2294)
      const matchedOption = testTypeQ?.options?.find((o: any) => o.option_value === 'tt_16' || o.option_desc?.toLowerCase() === 'not taken')
      if (matchedOption) {
        this.userInputService.setValue('english_testType', { option_label: matchedOption.option_label, option_value: matchedOption.option_value })
      } else if (englishTest.testType && englishTest.testTypeId) {
        this.userInputService.setValue('english_testType', { option_label: englishTest.testType, option_value: englishTest.testTypeId })
      }
      return
    }

    const isOthersById = englishTest.testTypeId === 'tt_11'
    const isOthersByDesc = englishTest.testDescription?.toLowerCase() === 'others'
    const isKnownTest = this.englishTestNames.some((t: any) => t.value?.toLowerCase() === englishTest.testType?.toLowerCase())
    const isOthers = isOthersById || isOthersByDesc || (!isKnownTest && englishTest.testType && englishTest.testTypeId)

    if (isOthers) {
      this.userInputService.setValue('english_testType', { option_label: 'Others', option_value: 'tt_11' })
      const customName = englishTest.testType || englishTest.otherTestTypeName || englishTest.otherTestName || null
      if (customName) {
        this.userInputService.setValue('other_english_testType', { option_value: customName, option_label: customName })
      }
    } else if (englishTest.testType && englishTest.testTypeId) {
      this.userInputService.setValue('english_testType', { option_label: englishTest.testType, option_value: englishTest.testTypeId })
    }
  }

  generateFormControl (ppQuestions: any): any {
    const formControl: any = {}
    if (ppQuestions) {
      ppQuestions.forEach((element: any) => {
        if (element.displayFormat.value === 'SELECT_BOX') {
          if (element.mappingField === 'englishIsFirstLanguage') {
            formControl[element.mappingField] = new FormControl('', element.mandatory ? [Validators.required] : [])
          } else if (element.mappingField === 'testType' && element.questionAttributeId === 2294) {
            formControl[element.mappingField] = new FormControl('')
            formControl.otherTestName = new FormControl('')
          }
        } else if (element.displayFormat.value === 'DATE_PICKER') {
          if (element.mappingField === 'testTakenDate' && element.questionAttributeId === 2305) {
            formControl[element.mappingField] = new FormControl('')
          }
        } else if (element.displayFormat.value === 'TEXT_BOX' || element.displayFormat.value === 'RANGE') {
          if (element.mappingField === 'overallScore' && element.questionAttributeId === 2320) {
            formControl[element.mappingField] = new FormControl('')
          }
        }
      })
    }
    this.englishProficiencyDetailsForm = new FormGroup(formControl)

    if (this.userInputService.getValue('english_testType')) {
      this.hasExistingEnglishTestData = true
    }

    // Set visibility flags first (reads from UserInputService directly)
    this.restoreVisibilityFlags()
    this.updateFormValidation()
    // Patch form values — keep isRestoring true through the entire async cycle
    // to prevent (selectionChange) events from triggering onInputChange side effects
    this.isRestoring = true
    this.restoreFormValues()
    // Also patch after a tick so any *ngIf fields that render late get their values
    setTimeout(() => {
      this.restoreFormValues()
      this.isRestoring = false
    })
    this.showEngDetailsLoader.set(false)
  }

  /**
   * Sets visibility flags by reading directly from UserInputService.
   * Does NOT touch the form — just determines which fields should be shown.
   */
  private restoreVisibilityFlags (): void {
    const englishIsFirst = this.userInputService.getValue('englishIsFirstLanguage')
    const englishVal = (typeof englishIsFirst === 'string' ? englishIsFirst : englishIsFirst?.option_value) || ''
    if (englishVal.toLowerCase() !== 'no') {
      this.showTestType = false
      this.showTestDate = false
      this.showOverallScore = false
      this.showOtherTestName = false
      return
    }
    this.showTestType = true
    const testTypeStored = this.userInputService.getValue('english_testType')
    const isOthers = testTypeStored?.option_value === 'tt_11'
    const isNotTakenStored = testTypeStored?.option_value === 'tt_16' || (testTypeStored?.option_desc || testTypeStored?.option_label)?.toLowerCase() === 'not taken'
    const testTypeLabel = testTypeStored?.option_label || ''

    if (isOthers) {
      this.showOtherTestName = true
      this.showTestDate = true
      this.showOverallScore = true
    } else if (testTypeLabel && !isNotTakenStored) {
      this.showTestDate = true
      this.showOverallScore = true
      this.updateTestScoreConfig(testTypeLabel)
    }
  }

  private restoreFormValues (): void {
    const storedData = this.userInputService.getAllValues()
    const patchValues: { [key: string]: any } = {}

    for (const key in storedData) {
      const value = storedData[key]
      if (this.shouldSkipKey(key)) {
        continue
      }

      const fieldName = this.getFieldName(key)
      patchValues[fieldName] = this.formatFieldValue(fieldName, key, value)
    }

    // Use emitEvent: false to prevent selectionChange from firing on chips/selects
    // which would trigger onInputChange and cause infinite loops or field clearing
    Object.keys(patchValues).forEach(field => {
      const control = this.englishProficiencyDetailsForm.get(field)
      if (control && patchValues[field] !== undefined && patchValues[field] !== null) {
        control.setValue(patchValues[field], { emitEvent: false })
      }
    })
  }

  private shouldSkipKey (key: string): boolean {
    const englishFields = ['englishIsFirstLanguage', 'english_testType', 'english_testTakenDate', 'english_overallScore', 'other_english_testType']
    return !englishFields.includes(key)
  }

  private getFieldName (key: string): string {
    if (key === 'other_english_testType') {
      return 'otherTestName'
    }
    return key.startsWith('english_') ? key.replace('english_', '') : key
  }

  private formatFieldValue (fieldName: string, key: string, value: any): any {
    if (fieldName === 'testTakenDate') {
      const dateValue = typeof value === 'string' ? value : value?.option_value
      return moment(dateValue, 'DD/MM/YYYY')
    }
    if (fieldName === 'englishIsFirstLanguage') {
      const raw = typeof value === 'string' ? value : value?.option_value
      const question = this.questions?.find((q: any) => q.mappingField === fieldName)
      if (question?.options) {
        const matched = question.options.find((opt: any) => opt.option_value?.toLowerCase() === raw?.toLowerCase())
        if (matched) return matched.option_value
      }
      return raw
    }
    if (fieldName === 'testType') {
      // mat-select uses option_label as [value]; match by testTypeId
      const storedId = typeof value === 'string' ? null : value?.option_value
      const storedLabel = typeof value === 'string' ? value : value?.option_label
      const question = this.questions?.find((q: any) => q.mappingField === 'testType' && q.questionAttributeId === 2294)
      if (question?.options) {
        // First try exact ID match
        if (storedId) {
          const matched = question.options.find((opt: any) => opt.option_value === storedId)
          if (matched) return matched.option_label
        }
        // For "Others" (tt_11), try matching by label variations
        if (storedId === 'tt_11') {
          const othersMatch = question.options.find((opt: any) =>
            ['others', 'other'].includes(opt.option_label?.toLowerCase())
          )
          if (othersMatch) return othersMatch.option_label
        }
        // Fallback: try matching by label (case-insensitive)
        if (storedLabel) {
          const matchedByLabel = question.options.find((opt: any) =>
            opt.option_label?.toLowerCase() === storedLabel?.toLowerCase()
          )
          if (matchedByLabel) return matchedByLabel.option_label
        }
      }
      // Last resort: log for debugging and return stored label
      console.warn('[EnglishProficiency] Could not match testType. storedId:', storedId, 'storedLabel:', storedLabel, 'available options:', question?.options)
      return storedLabel
    }
    if (fieldName === 'otherTestName') {
      return typeof value === 'string' ? value : (value?.option_value || value?.option_label)
    }
    return typeof value === 'string' ? value : value?.option_label
  }

  private restoreConditionalFields (): void {
    const englishIsFirstValue = this.getFormStringValue('englishIsFirstLanguage')
    if (englishIsFirstValue?.toLowerCase() !== 'no') {
      this.showTestType = false
      this.showTestDate = false
      this.showOverallScore = false
      return
    }
    this.showTestType = true
    this.restoreVisibilityFlags()
  }

  private getFormStringValue (field: string): string {
    const val = this.englishProficiencyDetailsForm.get(field)?.value
    return typeof val === 'string' ? val : val?.option_value
  }

  private getFormLabelValue (field: string): string {
    const val = this.englishProficiencyDetailsForm.get(field)?.value
    return typeof val === 'string' ? val : val?.option_label
  }

  updateTestScoreConfig (testName: string): void {
    if (!testName) {
      this.testScoreConfig = null
      return
    }
    const selectedTest = this.englishTestNames.find((test: any) => test.value === testName)
    if (selectedTest) {
      this.testScoreConfig = {
        min: selectedTest.min,
        max: selectedTest.max === 'infinity' ? null : selectedTest.max
      }
      const overallScoreControl = this.englishProficiencyDetailsForm.get('overallScore')
      if (overallScoreControl) {
        const validators = [Validators.required]
        if (this.testScoreConfig.min !== null) {
          validators.push(Validators.min(this.testScoreConfig.min))
        }
        if (this.testScoreConfig.max !== null) {
          validators.push(Validators.max(this.testScoreConfig.max))
        }
        overallScoreControl.setValidators(validators)
        overallScoreControl.updateValueAndValidity()
      }
    } else {
      this.testScoreConfig = null
    }
  }

  updateFormValidation (): void {
    const englishIsFirstValue = this.getFormStringValue('englishIsFirstLanguage')
    const testTypeName = this.getFormLabelValue('testType')

    const controls = {
      testType: this.englishProficiencyDetailsForm.get('testType'),
      testDate: this.englishProficiencyDetailsForm.get('testTakenDate'),
      score: this.englishProficiencyDetailsForm.get('overallScore'),
      otherTestName: this.englishProficiencyDetailsForm.get('otherTestName')
    }

    if (englishIsFirstValue?.toLowerCase() === 'yes') {
      this.clearAllTestValidators(controls.testType, controls.testDate, controls.score, controls.otherTestName)
    } else if (englishIsFirstValue?.toLowerCase() === 'no') {
      const testTypeQ = this.questions?.find((q: any) => q.mappingField === 'testType' && q.questionAttributeId === 2294)
      if (testTypeQ?.mandatory) {
        controls.testType?.setValidators([Validators.required])
      } else {
        controls.testType?.clearValidators()
      }
      this.setValidatorsForNoEnglish(testTypeName, controls)
    }

    Object.values(controls).forEach(c => c?.updateValueAndValidity())
  }

  private setValidatorsForNoEnglish (testTypeName: string, controls: any): void {
    const storedTestType = this.userInputService.getValue('english_testType')
    const isOthers = storedTestType?.option_value === 'tt_11' || testTypeName?.toLowerCase() === 'others'
    const isNotTaken = storedTestType?.option_value === 'tt_16' || (storedTestType?.option_desc || testTypeName)?.toLowerCase() === 'not taken'
    if (isOthers) {
      controls.testDate?.setValidators([Validators.required])
      controls.score?.setValidators([Validators.required])
      controls.otherTestName?.setValidators([Validators.required])
    } else if (testTypeName && !isNotTaken) {
      controls.testDate?.setValidators([Validators.required])
      controls.otherTestName?.clearValidators()
      this.updateTestScoreConfig(testTypeName)
    } else {
      controls.testDate?.clearValidators()
      controls.score?.clearValidators()
      controls.otherTestName?.clearValidators()
    }
  }

  private clearAllTestValidators (...controls: any[]): void {
    controls.forEach(c => c?.clearValidators())
  }

  onDateChange (event: any, field: string): void {
    this.invalidTestDate = false
    this.futureTestDate = false
    const storageKey = this.getStorageKey(field)
    const d = moment(event.value).format('DD/MM/YYYY')
    if (!(d.match(/^\d{2}\/\d{2}\/\d{4}$/) && d.includes('/'))) {
      this.userInputService.deleteValue(storageKey)
      this.invalidTestDate = true
    } else {
      const selectedDate = moment(event.value, 'DD/MM/YYYY')
      const todayDate = moment().startOf('day')
      const formattedDate = selectedDate.format('DD/MM/YYYY')

      if (selectedDate.isAfter(todayDate)) {
        this.userInputService.deleteValue(storageKey)
        this.futureTestDate = true
      } else {
        this.userInputService.setValue(storageKey, { option_value: formattedDate, option_label: formattedDate })
      }
    }
  }

  onInputString (field: string, event: FocusEvent): void {
    const inputElement = event.target as HTMLInputElement
    const trimmedValue = inputElement.value.trim()

    inputElement.value = trimmedValue
    this.userInputService.setValue(this.getStorageKey(field), { option_value: trimmedValue, option_label: trimmedValue })
    this.englishProficiencyDetailsForm.get(field)?.setValue(trimmedValue)
  }

  preventEnter (event: Event): void {
    const keyboardEvent = event as KeyboardEvent
    keyboardEvent.preventDefault()
    keyboardEvent.stopPropagation()
  }

  getStorageKey (field: string): string {
    if (field === 'testType' || field === 'testTakenDate' || field === 'overallScore') {
      return `english_${field}`
    }
    if (field === 'otherTestName') {
      return 'other_english_testType'
    }
    return field
  }

  nextButton (): void {
    this.submitted = true
    this.updateFormValidation()
    this.ensureHiddenFieldsHaveNoValidation()
    if (this.invalidTestDate || this.futureTestDate) {
      const invalidControl = document.querySelector(
        'form .ng-invalid, form .date-error'
      ) as HTMLElement

      if (invalidControl) {
        invalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' })
        setTimeout(() => {
          const elementToFocus =
            invalidControl.querySelector('input, [type="checkbox"], mat-select') ||
            invalidControl
          elementToFocus.classList.add('scroll-field-error');
          (elementToFocus as HTMLElement).focus()
        }, 300)
      }
      return
    }

    if (this.englishProficiencyDetailsForm.valid) {
      this.gtmImplementation.trackEvents('wir_english_proficiency', 'next_button', 'next', 'english_proficiency', 'signed_in_user', 'user_registration')
      this.nextClicked.emit()
    } else {
      const invalidControl = document.querySelector(
        'form .ng-invalid'
      ) as HTMLElement

      if (invalidControl) {
        invalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' })
        setTimeout(() => {
          const elementToFocus =
            invalidControl.querySelector('input, [type="checkbox"], mat-select') ||
            invalidControl
          elementToFocus.classList.add('scroll-field-error');
          (elementToFocus as HTMLElement).focus()
        }, 300)
      }
    }
  }

  private ensureHiddenFieldsHaveNoValidation (): void {
    const englishIsFirst = this.englishProficiencyDetailsForm.get('englishIsFirstLanguage')?.value
    const englishIsFirstValue = typeof englishIsFirst === 'string' ? englishIsFirst : englishIsFirst?.option_value
    const testType = this.englishProficiencyDetailsForm.get('testType')?.value
    const testTypeName = typeof testType === 'string' ? testType : testType?.option_label
    const storedTestTypeForHidden = this.userInputService.getValue('english_testType')
    const isNotTakenHidden = storedTestTypeForHidden?.option_value === 'tt_16' || (storedTestTypeForHidden?.option_desc || testTypeName)?.toLowerCase() === 'not taken'

    const fieldsToCheck = [
      { show: this.showTestType && englishIsFirstValue?.toLowerCase() === 'no', field: 'testType' },
      { show: this.showTestDate && testTypeName && !isNotTakenHidden, field: 'testTakenDate' },
      { show: this.showOverallScore && testTypeName && !isNotTakenHidden, field: 'overallScore' },
      { show: this.showOtherTestName, field: 'otherTestName' }
    ]
    const hiddenFields = fieldsToCheck.filter(f => !f.show).map(f => f.field)
    this.formFieldHelper.clearValidatorsAndUpdate(this.englishProficiencyDetailsForm, hiddenFields)
  }

  backButton (): void {
    this.gtmImplementation.trackEvents('wir_english_proficiency', 'back_button', 'back', 'english_proficiency', 'signed_in_user', 'user_registration')
    this.backClicked.emit()
  }

  scrollToTop (): void {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
 
  ngOnDestroy (): void {
    clearTimeout(this.scrollTimer)
  }
}
